var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createStyles = void 0;
var createStyles_1 = __importDefault(require("@material-ui/core/styles/createStyles"));
exports.createStyles = createStyles_1.default;
exports.default = exports.createStyles;
//# sourceMappingURL=createStyles.js.map